import React from 'react';
import { formatLatency } from '../../shared/domain/formatters';

export type MultiAssetHealthState =
  | 'HEALTHY'
  | 'DEGRADED'
  | 'STOPPING'
  | 'STOPPED'
  | 'DISCONNECTED'
  | 'UNCONFIGURED';

export interface HealthStatusBadgeProps {
  status: MultiAssetHealthState | string;
  showDetails?: boolean;
  lagSeconds?: number | null;
  className?: string;
}

export const HealthStatusBadge: React.FC<HealthStatusBadgeProps> = ({
  status,
  showDetails = false,
  lagSeconds,
  className = '',
}) => {
  const normStatus = (status || 'UNCONFIGURED').toUpperCase() as MultiAssetHealthState;

  let bg = 'var(--tag-inactive-bg)';
  let color = 'var(--text-muted)';
  let border = 'var(--border-subtle)';
  let icon = '⚪';
  let label = '未配置';

  switch (normStatus) {
    case 'HEALTHY':
      bg = 'var(--badge-bullish-bg)';
      color = 'var(--color-emerald)';
      border = 'var(--badge-bullish-border)';
      icon = '🟢';
      label = '调度健康 (HEALTHY)';
      break;
    case 'DEGRADED':
      bg = 'var(--badge-warning-bg)';
      color = 'var(--color-warning)';
      border = 'var(--badge-warning-border)';
      icon = '🟡';
      label = '降级运行 (DEGRADED)';
      break;
    case 'STOPPING':
      bg = 'var(--badge-info-bg)';
      color = 'var(--color-cyan)';
      border = 'var(--badge-info-border)';
      icon = '⏳';
      label = '正在停机 (STOPPING)';
      break;
    case 'STOPPED':
      bg = 'var(--badge-neutral-bg)';
      color = 'var(--text-muted)';
      border = 'var(--badge-neutral-border)';
      icon = '⏸️';
      label = '调度已停止 (STOPPED)';
      break;
    case 'DISCONNECTED':
      bg = 'var(--badge-bearish-bg)';
      color = 'var(--color-bearish)';
      border = 'var(--badge-bearish-border)';
      icon = '🔴';
      label = '存储离线 (DISCONNECTED)';
      break;
    case 'UNCONFIGURED':
    default:
      bg = 'var(--tag-inactive-bg)';
      color = 'var(--text-muted)';
      border = 'var(--border-subtle)';
      icon = '⚪';
      label = '未初始化 (UNCONFIGURED)';
      break;
  }

  return (
    <span
      className={`health-status-badge ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '3px 8px',
        borderRadius: '6px',
        fontSize: '11px',
        fontWeight: 600,
        backgroundColor: bg,
        color: color,
        border: `1px solid ${border}`,
        whiteSpace: 'nowrap',
      }}
      title={`多资产调度器状态: ${label}${lagSeconds !== undefined && lagSeconds !== null ? ` (时延: ${formatLatency(lagSeconds)})` : ''}`}
    >
      <span>{icon}</span>
      <span>{label}</span>
      {showDetails && lagSeconds !== undefined && lagSeconds !== null && (
        <span style={{ opacity: 0.85, fontSize: '10px' }}>
          ({formatLatency(lagSeconds)})
        </span>
      )}
    </span>
  );
};
